import React from "react"
import { isNullOrUndefined } from "../../utils"

export default class HighlightedText extends React.Component {
  render() {
    const { text, highlight } = this.props

    // all highlights are bolded
    // if TopAnswer is provided and true, it has a yellow background
    return (
      <strong
        className={
          !isNullOrUndefined(highlight.TopAnswer) && highlight.TopAnswer
            ? "top-answer"
            : ""
        }
      >
        {!isNullOrUndefined(text) &&
          text?.substring(highlight.BeginOffset, highlight.EndOffset)}
      </strong>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/resultsPanel/components/Highlight.js